export default __webpack_public_path__ + "static/media/contactsGreen.47f34fc6.svg";